import {get,post} from '../utils/http'
// var baseUrl = "http://124.70.161.74:960/scom/power"
// var baseUrl ="/scom/power"
// var baseUrl ="http://192.168.32.77:960/scom/power"

//获取天气
export function weather(data){
    let url = "http://wthrcdn.etouch.cn/weather_mini?city="+data;
    const weather = get(url);
    return weather;
} 